import { Component, Input } from '@angular/core';

@Component({
  selector: 'card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {

  @Input() title: string;
  @Input() description: string;
  @Input() icon: string;
  @Input() notes: string;

  constructor() {
  }
}
